import React from "react";
import PolicyEmbed from "./PolicyEmbed";

export default function AcceptableUsePage() {

  return <PolicyEmbed title="Acceptable Use Policy"
                      src="https://app.termly.io/policy-viewer/policy.html?policyUUID=75881f0f-ff27-4fc0-93b5-2031b8fe3436"
                      height={4000} />

}
